import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class FsScrollbarService {
    constructor() {
        this.renderScrollbarStyle();
    }
    getStyleEl() {
        return document.getElementById('fs-scrollbar-style');
    }
    renderScrollbarStyle() {
        let el = this.getStyleEl();
        if (el) {
            el.remove();
        }
        el = document.createElement('style');
        el.setAttribute('id', 'fs-scrollbar-style');
        document.getElementsByTagName('head')[0].appendChild(el);
        const style = `::-webkit-scrollbar {
        height: 6px;
        width: 6px;
        scrollbar-width: none;
      }

      ::-webkit-scrollbar-thumb {
        background-color: rgba(166, 164, 164, 0.65);
        outline: none;
        border-radius: 44px;
      }

      * {
        scrollbar-color: rgba(166, 164, 164, 0.65) transparent;
        scrollbar-width: thin;
      }
      `;
        el.innerHTML = '';
        el.appendChild(document.createTextNode(style));
    }
}
FsScrollbarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsScrollbarService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FsScrollbarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsScrollbarService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsScrollbarService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class FsScrollbarModule {
    constructor(fsScrollbarService) {
        this.fsScrollbarService = fsScrollbarService;
    }
    static forRoot() {
        return {
            ngModule: FsScrollbarModule,
            providers: [FsScrollbarService]
        };
    }
}
FsScrollbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsScrollbarModule, deps: [{ token: FsScrollbarService }], target: i0.ɵɵFactoryTarget.NgModule });
FsScrollbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsScrollbarModule, imports: [CommonModule] });
FsScrollbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsScrollbarModule, providers: [
        FsScrollbarService
    ], imports: [[
            CommonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsScrollbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    providers: [
                        FsScrollbarService
                    ]
                }]
        }], ctorParameters: function () { return [{ type: FsScrollbarService }]; } });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsScrollbarModule };
